import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register PWA service worker (production builds and preview only).
// The worker is served from /sw.js at the site root (public/sw.js).
// Disabled on embedded iframe mode to avoid caching inside third-party sites.
if ("serviceWorker" in navigator) {
  const isEmbed =
    typeof window !== "undefined" && window.location.pathname.startsWith("/embed");
  if (!isEmbed) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  }
}
